const signalR = window.signalR;

import { SIGNALR_BASE_URL } from "@/services/BaseUrl";

import store from "@/store/index";

// SignalR bağlantısını kur
const connection = new signalR.HubConnectionBuilder()
  .withUrl(`${SIGNALR_BASE_URL}/fileProgressHub`, {
    skipNegotiation: false,
    transport: signalR.HttpTransportType.WebSockets,
    withCredentials: true,
  })
  .configureLogging(signalR.LogLevel.Information)
  .build();

// Log mesajlarını ekrana yazdırmak için yardımcı fonksiyon
function log(message) {
  console.log(message);
}

// İlerleme bilgisini dinle
connection.on("ReceiveProgress", (progress) => {
  store.commit("SET_DOWNLOAD_ACTION", progress);
  // Log mesajı oluştur
  const message = `Dosya: ${progress.fileName}
İlerleme: ${progress.currentFile}/${progress.totalFiles}
Yüzde: ${progress.percentage}%
Klasör: ${progress.folderPath}
------------------------`;
  log(message);
});

// Hata durumunu dinle
connection.on("ReceiveError", (error) => {
  log(`❌ HATA: ${error.fileName}`);
});

// Bağlantıyı başlat
connection
  .start()
  .then(() => log("✅ SignalR Bağlantısı kuruldu"))
  .catch((err) => log("❌ SignalR Bağlantı hatası: " + err));
